import { useMemo } from "react";
import { Conversation } from "@/types";
import {
  isPageReady as checkIsPageReady,
  isFatalError as checkIsFatalError,
  isSummaryLoading as checkIsSummaryLoading,
  isSummaryErrored as checkIsSummaryErrored,
  getSummaryErrorReason as checkGetSummaryErrorReason,
  isCoachingStepErrored as checkIsCoachingStepErrored,
  getCoachingStepErrorReason as checkGetCoachingStepErrorReason,
  isDataExtractionStepErrored as checkIsDataExtractionStepErrored,
  getDataExtractionStepErrorReason as checkGetDataExtractionStepErrorReason,
} from "@/components/pages/Conversations/ConversationsDetails/utils/processingSteps";

export const useProcessingStepFlags = (conversation: Conversation | undefined) => {
  const isConversationPageReady = useMemo(
    () => checkIsPageReady(conversation),
    [conversation],
  );
  const isConversationFatalError = useMemo(
    () => checkIsFatalError(conversation),
    [conversation],
  );
  const isSummaryStepLoading = useMemo(
    () => checkIsSummaryLoading(conversation),
    [conversation],
  );
  const isSummaryStepErrored = useMemo(
    () => checkIsSummaryErrored(conversation),
    [conversation],
  );
  const summaryErrorReason = useMemo(
    () => checkGetSummaryErrorReason(conversation),
    [conversation],
  );
  const isCoachingStepErrored = useMemo(
    () => checkIsCoachingStepErrored(conversation),
    [conversation],
  );
  const coachingStepErrorReason = useMemo(
    () => checkGetCoachingStepErrorReason(conversation),
    [conversation],
  );
  const isDataExtractionStepErrored = useMemo(
    () => checkIsDataExtractionStepErrored(conversation),
    [conversation],
  );
  const dataExtractionStepErrorReason = useMemo(
    () => checkGetDataExtractionStepErrorReason(conversation),
    [conversation],
  );

  return {
    isConversationPageReady,
    isConversationFatalError,
    isSummaryStepLoading,
    isSummaryStepErrored,
    summaryErrorReason,
    isCoachingStepErrored,
    coachingStepErrorReason,
    isDataExtractionStepErrored,
    dataExtractionStepErrorReason,
  };
};
